// tslint:disable-next-line:variable-name
const Grocery = {
    MAIN     : 1,
    SECONDARY: 2,
};

export {
    Grocery,
};
